import {
  LazyAccordionContentBlock,
  LazyAnchorNavigationBar,
  LazyAnchorTag,
  Banner,
  LazyBasicContentBlock,
  LazyCallToAction,
  LazyContactBlock,
  LazyIconCollection,
  LazyIconItem,
  LazyIFrame,
  LazyImageBlock,
  LazyLogoCollection,
  LazyLogoItem,
  LazyMediaBlock,
  LazyModuleCardItem,
  LazyPartnerCardItem,
  LazyPartnerList,
  LazyPlatformBasicContentBlock,
  LazyPlatformSplitContentBlock,
  LazyPublicationList,
  LazyRichTextHorizontalLine,
  LazySectionBreak,
  LazySplitContentBlock,
  LazySplitContentBlockBasic,
  LazySplitContentBlockImage,
  LazyTeamList,
  LazyTeamMember
} from '#components'
import { contentTypes } from '~/models'

// Define the mapping of content types to their respective components
const components: { [key: string]: any } = {
  // blocks
  [contentTypes.section_break.codename]: LazySectionBreak,
  [contentTypes.basic_content_block.codename]: LazyBasicContentBlock,
  [contentTypes.split_content_block.codename]: LazySplitContentBlock,
  [contentTypes.split_content_block_basic_content.codename]: LazySplitContentBlockBasic,
  [contentTypes.split_content_block_image.codename]: LazySplitContentBlockImage,
  [contentTypes.iframe.codename]: LazyIFrame,
  [contentTypes.logo_item.codename]: LazyLogoItem,
  [contentTypes.icon_item.codename]: LazyIconItem,
  [contentTypes._horizontal_rule.codename]: LazyRichTextHorizontalLine,
  [contentTypes.platform_page_basic_content_block.codename]: LazyPlatformBasicContentBlock,
  [contentTypes.platform_page_split_content_block.codename]: LazyPlatformSplitContentBlock,
  [contentTypes.contact_block.codename]: LazyContactBlock,
  [contentTypes.image_block.codename]: LazyImageBlock,
  [contentTypes.media_block.codename]: LazyMediaBlock,
  [contentTypes.partner_item.codename]: LazyPartnerCardItem,
  [contentTypes.module_item.codename]: LazyModuleCardItem,
  [contentTypes.team_member.codename]: LazyTeamMember,
  [contentTypes.anchor_tag.codename]: LazyAnchorTag,
  [contentTypes.accordion_content_block.codename]: LazyAccordionContentBlock,


  // collections
  [contentTypes.team_list.codename]: LazyTeamList,
  [contentTypes.partner_list.codename]: LazyPartnerList,
  [contentTypes.news_media_list.codename]: LazyPublicationList,
  [contentTypes.icon_collection.codename]: LazyIconCollection,
  [contentTypes.logo_collection.codename]: LazyLogoCollection,

  // rich texts
  [contentTypes.call_to_action.codename]: LazyCallToAction,

  // helpers
  [contentTypes._anchor_navigation_bar.codename]: LazyAnchorNavigationBar

}

export default function (type: string) {
  return components[type]
}
